import './js/index.js'
import './assets/scss/main.scss'

window.env = process.env.ARTPRO_MODE || 'production';
window.apiUrl = process.env.ARTPRO_API_URL || 'https://api.artpro.art';
window.socketUrl = process.env.ARTPRO_SOCKET_URL || 'https://api.artpro.art';


window.stripePublicKey = process.env.STRIPE_PUBLIC_KEY
window.summerNoteConfig = {
    lang: "ru-RU",
    styleTags: [
        'p',
        // { title: 'Blockquote', tag: 'blockquote', className: 'blockquote', value: 'blockquote' },
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
    ],

    toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        // ['fontname', ['fontname']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link', 'hello', 'video']], //'picture',
        ['view', ['fullscreen', 'codeview']]

    ],
    height: 350
};
window.currentLang = 'ru';
window.enableCheckProfile = false;
window.getUrlParams = function () {
    let getParams = location.search.replace('?', '').split('&');
    let params = {};
    getParams.forEach(function (paramsString) {
        let param = paramsString.split('=');
        params[param[0]] = param[1];
    });

    return params;
}

window.isNumber = function (evt, allowDecimal = false, allowNegative = false) {
    const value = event.target.value


    let pattern = '^'

    if (allowNegative) {
        pattern += '-?'
    }

    pattern += '\\d*'

    if (allowDecimal) {
        pattern += '(\\.\\d*)?'
    }

    pattern += '$'

    const numberRegex = new RegExp(pattern)

    return value === '' || numberRegex.test(value);


};

// Функции для получения base64 из инпута
File.prototype.convertToBase64 = function (callback) {
    let reader = new FileReader();
    reader.onloadend = function (e) {
        callback(e.target.result, e.target.error);
    };
    reader.readAsDataURL(this);
};

axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['domain'] = location.host;

import Vue from 'vue'
import App from './App.vue'
import store from './store'
import Vuelidate from 'vuelidate'
import VueSignaturePad from 'vue-signature-pad';


Vue.use(Vuelidate)
Vue.use(VueSignaturePad)
Vue.config.productionTip = false;
import router from './router' // надо после vuex

const VueInputMask = require('vue-inputmask').default

Vue.use(VueInputMask)

Vue.filter('subStr', function (string, length, needPoints) {
    if (!string) return string;
    if (needPoints === undefined) needPoints = true;

    if (string.length > length) {
        return string.substring(0, length) + (needPoints ? '...' : '');
    }
    return string;
})
import Echo from 'laravel-echo';

window.io = require('socket.io-client');

if (window.env === 'production') {
// if (true) {
    window.echoInstance = new Echo({
        broadcaster: 'socket.io',
        host: window.socketUrl + ':443',
    });
}




window.downloadFile = function (fileId, prefix = '') {
    axios.get(window.apiUrl + '/api/files/download/' + fileId, {
        params: {
            prefix: prefix
        },
    })
        .then(response => {
            const link = document.createElement('a');
            link.href = response.data.url;
            // link.setAttribute('download', response.headers['content-disposition'].split('filename=')[1]);
            document.body.appendChild(link);
            link.click();
            link.remove();
        });
}

const app = new Vue({
    el: '#kt_body',
    router,
    store,
    components: {App},
    template: '<App/>'
})

